import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiDialogTitle(theme: Theme): MuiThemeComponentOverride<"MuiDialogTitle"> {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.brand.grey[100].main,
          padding: "16px",
        },
      },
    },
  };
}
